import React, { useState, useEffect } from "react";
import {
  Box,
  CircularProgress,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Alert,
  Snackbar,
} from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import AddIcon from "@mui/icons-material/Add";
import SaleAmountAdjustmentHandler from "./SaleAmountAdjustmentHandler";
import RefundForm from "./RefundForm";
import config from "./global/config";

const SaleDetailsGrid = ({
  saleDetails = [],
  products = [],
  loading = false,
  colors,
  onAddDetail,
  onEditDetail,
  onDeleteDetail,
  saleId,
  onRefreshSaleDetails,
}) => {
  // State Management
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [isAdjustmentModalOpen, setIsAdjustmentModalOpen] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [error, setError] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [refundAmount, setRefundAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [paymentPlanId, setPaymentPlanId] = useState(null);

  const [formData, setFormData] = useState({
    id_produit: "",
    quantite: "",
    prix_vente_unitaire: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (formData.id_produit) {
      const product = products.find(
        (p) => p.id_produit === formData.id_produit
      );
      setSelectedProduct(product);
    }
  }, [formData.id_produit, products]);

  // 1. First, define a single fetchPaidAmount function outside useEffect
  const fetchPaidAmount = async () => {
    if (!saleId) return;

    try {
      // First get the payment plan ID
      const planResponse = await fetch(
        `${config.apiUrl}/paiements_clients_tranches.php?id_vente=${saleId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const planData = await planResponse.json();

      let totalPaid = 0;

      // If there's a payment plan, fetch its payments
      if (planData && planData.length > 0) {
        const paymentPlanId = planData[0].id_paiement_tranche;
        setPaymentPlanId(paymentPlanId);

        const paymentsResponse = await fetch(
          `${config.apiUrl}/reglements_tranches_clients.php?id_paiement_tranche=${paymentPlanId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const paymentsData = await paymentsResponse.json();

        if (Array.isArray(paymentsData)) {
          totalPaid = paymentsData
            .filter((payment) => payment.statut_reglements === "Payé")
            .reduce(
              (sum, payment) => sum + parseFloat(payment.montant || 0),
              0
            );
        }
      }

      // Also check for any cash payments
      const cashResponse = await fetch(
        `${config.apiUrl}/paiements_clients_cash.php?id_vente=${saleId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const cashData = await cashResponse.json();

      if (Array.isArray(cashData)) {
        totalPaid += cashData.reduce(
          (sum, payment) => sum + parseFloat(payment.montant || 0),
          0
        );
      }

      //console.log("Total paid amount:", totalPaid);
      setPaidAmount(totalPaid);
    } catch (error) {
      //console.error("Error fetching paid amount:", error);
      setPaidAmount(0);
    }
  };

  // 2. Then use it in useEffect
  useEffect(() => {
    if (saleId) {
      fetchPaidAmount();
      fetchPaymentPlanId();
    }
  }, [saleId]); // Include fetchPaidAmount in dependencies if needed

  // 3. Remove the duplicate useEffect with fetchPaidAmount

  // useEffect(() => {
  //   if (saleId) {
  //     fetchPaidAmount();
  //   }
  // }, [saleId]);

  // const fetchPaidAmount = async () => {
  //   if (!saleId) return;

  //   try {
  //     // First get payment plan
  //     const planResponse = await fetch(
  //       `${config.apiUrl}/paiements_clients_tranches.php?id_vente=${saleId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );

  //     if (!planResponse.ok) {
  //       throw new Error("Failed to fetch payment plan");
  //     }

  //     const planData = await planResponse.json();

  //     if (planData && planData.length > 0) {
  //       const paymentPlanId = planData[0].id_paiement_tranche;
  //       setPaymentPlanId(paymentPlanId);

  //       // Get payments for this plan
  //       const paymentsResponse = await fetch(
  //         `${config.apiUrl}/reglements_tranches_clients.php?id_paiement_tranche=${paymentPlanId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           },
  //         }
  //       );

  //       if (!paymentsResponse.ok) {
  //         throw new Error("Failed to fetch payments");
  //       }

  //       const payments = await paymentsResponse.json();
  //       const totalPaid = payments
  //         .filter((p) => p.statut_reglements === "Payé")
  //         .reduce((sum, p) => sum + parseFloat(p.montant || 0), 0);

  //       setPaidAmount(totalPaid);
  //     }
  //   } catch (error) {
  //     //console.error("Error fetching paid amount:", error);
  //     setPaidAmount(0);
  //   }
  // };

  // useEffect(() => {
  //   const fetchPaidAmount = async () => {
  //     try {
  //       const response = await fetch(
  //         `${config.apiUrl}/reglements_tranches_clients.php?id_vente=${saleId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           },
  //         }
  //       );
  //       const data = await response.json();
  //       const totalPaid = Array.isArray(data)
  //         ? data
  //             .filter((payment) => payment.statut_reglements === "Payé")
  //             .reduce(
  //               (sum, payment) => sum + parseFloat(payment.montant || 0),
  //               0
  //             )
  //         : 0;
  //       //console.log("Fetched paid amount:", totalPaid);
  //       setPaidAmount(totalPaid);
  //     } catch (error) {
  //       //console.error("Error fetching paid amount:", error);
  //     }
  //   };

  //   if (saleId) {
  //     fetchPaidAmount();
  //   }
  // }, [saleId]);

  // const fetchPaidAmount = async () => {
  //   try {
  //     let totalPaid = 0;

  //     // Fetch installment payments
  //     if (paymentPlanId) {
  //       const installmentResponse = await fetch(
  //         `${config.apiUrl}/reglements_tranches_clients.php?id_paiement_tranche=${paymentPlanId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           },
  //         }
  //       );
  //       const installmentData = await installmentResponse.json();
  //       totalPaid += Array.isArray(installmentData)
  //         ? installmentData
  //             .filter((payment) => payment.statut_reglements === "Payé")
  //             .reduce(
  //               (sum, payment) => sum + parseFloat(payment.montant || 0),
  //               0
  //             )
  //         : 0;
  //     }

  //     // Fetch cash payments
  //     const cashResponse = await fetch(
  //       `${config.apiUrl}/paiements_clients_cash.php?id_vente=${saleId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     const cashData = await cashResponse.json();
  //     totalPaid += Array.isArray(cashData)
  //       ? cashData.reduce(
  //           (sum, payment) => sum + parseFloat(payment.montant || 0),
  //           0
  //         )
  //       : 0;

  //     setPaidAmount(totalPaid);
  //   } catch (error) {
  //     //console.error("Error fetching paid amount:", error);
  //     setError("Failed to fetch payment information");
  //   }
  // };

  const fetchPaymentPlanId = async () => {
    try {
      const response = await fetch(
        `${config.apiUrl}/paiements_clients_tranches.php?id_vente=${saleId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      if (data && data.length > 0) {
        setPaymentPlanId(data[0].id_paiement_tranche);
      }
    } catch (error) {
      //console.error("Error fetching payment plan:", error);
    }
  };

  const calculateTotalAmount = (details) => {
    return details.reduce((total, detail) => {
      return total + detail.quantite * detail.prix_vente_unitaire;
    }, 0);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.id_produit) {
      throw new Error("Please select a product");
    }
    if (!formData.quantite || formData.quantite <= 0) {
      throw new Error("Please enter a valid quantity");
    }
    if (!formData.prix_vente_unitaire || formData.prix_vente_unitaire <= 0) {
      throw new Error("Please enter a valid unit price");
    }

    if (!selectedProduct) {
      throw new Error("Product not found");
    }

    const currentStock = selectedProduct.stock_actuel;
    const requestedQuantity = parseInt(formData.quantite);

    if (isEditModalOpen && selectedDetail) {
      const additionalQuantity = requestedQuantity - selectedDetail.quantite;
      if (additionalQuantity > currentStock) {
        throw new Error(
          `Insufficient stock. Available: ${currentStock}, Additional requested: ${additionalQuantity}`
        );
      }
    } else if (requestedQuantity > currentStock) {
      throw new Error(
        `Insufficient stock. Available: ${currentStock}, Requested: ${requestedQuantity}`
      );
    }
  };

  const handleRefundProcess = async (refundData) => {
    try {
      const requestData = {
        ...refundData,
        id_vente: saleId,
        id_paiement_tranche: paymentPlanId,
        montant_refund: refundAmount,
        motif: "Modification vente",
        user_cre: localStorage.getItem("username") || "SYSTEM",
      };

      const response = await fetch(`${config.apiUrl}/refund_handler.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error("Failed to process refund");
      }

      // After successful refund, process the original operation
      if (selectedDetail) {
        if (isEditModalOpen) {
          await onEditDetail(selectedDetail.id_detail_vente, formData);
        } else {
          await onDeleteDetail(selectedDetail.id_detail_vente);
        }
      }

      // Close all modals
      setIsRefundModalOpen(false);
      setIsAdjustmentModalOpen(false);
      setIsEditModalOpen(false);
      setIsDeleteModalOpen(false);

      // Refresh data
      if (onRefreshSaleDetails) {
        await onRefreshSaleDetails();
      }

      // showNotification("Operation completed successfully");
    } catch (error) {
      //console.error("Error processing refund:", error);
      // showNotification(error.message, "error");
    }
  };

  const handleEdit = async () => {
    try {
      validateForm();

      // Calculate amounts
      const currentDetailAmount = parseFloat(selectedDetail.montant_total);
      const newDetailAmount = formData.quantite * formData.prix_vente_unitaire;
      const currentTotal = calculateTotalAmount(saleDetails);
      const newTotal = currentTotal - currentDetailAmount + newDetailAmount;
      const difference = currentTotal - newTotal;

      // Get pending payments total
      const response = await fetch(
        `${config.apiUrl}/reglements_tranches_clients.php?id_paiement_tranche=${paymentPlanId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const payments = await response.json();
      const pendingTotal = payments
        .filter((p) => p.statut_reglements === "En attente")
        .reduce((sum, p) => sum + parseFloat(p.montant), 0);

      // Scenario 1: If difference equals pending payments
      if (difference > 0 && Math.abs(difference - pendingTotal) < 0.01) {
        // Just update without showing refund dialog
        await onEditDetail(selectedDetail.id_detail_vente, formData);
        setIsEditModalOpen(false);
      }
      // Other scenarios where refund UI is needed
      else if (newTotal < currentTotal) {
        const refundNeeded = Math.min(
          currentTotal - newTotal,
          paidAmount - newTotal
        );
        setRefundAmount(refundNeeded);
        setSelectedDetail({
          ...selectedDetail,
          calculated: {
            currentTotal: currentTotal,
            newTotal: newTotal,
          },
        });
        setIsAdjustmentModalOpen(true);
      } else {
        await onEditDetail(selectedDetail.id_detail_vente, formData);
        setIsEditModalOpen(false);
      }
    } catch (error) {
      console.error("Error in handleEdit:", error);
      setSnackbar({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDelete = async () => {
    try {
      // First get payment plan info
      const planResponse = await fetch(
        `${config.apiUrl}/paiements_clients_tranches.php?id_vente=${saleId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const planData = await planResponse.json();
      const paymentId =
        planData && planData.length > 0
          ? planData[0].id_paiement_tranche
          : null;

      // Calculate totals
      const currentTotal = calculateTotalAmount(saleDetails);
      const detailsWithoutSelected = saleDetails.filter(
        (detail) => detail.id_detail_vente !== selectedDetail.id_detail_vente
      );
      const newTotal = calculateTotalAmount(detailsWithoutSelected);
      const difference = currentTotal - newTotal;

      if (paymentId) {
        // Get pending payments info
        const paymentsResponse = await fetch(
          `${config.apiUrl}/reglements_tranches_clients.php?id_paiement_tranche=${paymentId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const payments = await paymentsResponse.json();
        const pendingPayments = payments.filter(
          (p) => p.statut_reglements === "En attente"
        );
        const pendingTotal = pendingPayments.reduce(
          (sum, p) => sum + parseFloat(p.montant),
          0
        );

        // Scenario 1: Difference equals pending payments
        if (Math.abs(difference - pendingTotal) < 0.01) {
          // Just delete without showing refund dialog
          await onDeleteDetail(selectedDetail.id_detail_vente);
          setIsDeleteModalOpen(false);
          return;
        }
      }

      // Other scenarios where refund might be needed
      if (paidAmount > newTotal) {
        const refundAmt = Math.min(
          currentTotal - newTotal,
          paidAmount - newTotal
        );
        setRefundAmount(refundAmt);
        setSelectedDetail({
          ...selectedDetail,
          calculated: {
            currentTotal: currentTotal,
            newTotal: newTotal,
          },
        });
        setIsAdjustmentModalOpen(true);
      } else {
        // Regular delete
        await onDeleteDetail(selectedDetail.id_detail_vente);
        setIsDeleteModalOpen(false);
      }
    } catch (error) {
      console.error("Error in handleDelete:", error);
      setSnackbar({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };
  const handleAdd = async () => {
    try {
      // Validate the form
      if (!formData.id_produit) {
        throw new Error("Please select a product");
      }
      if (!formData.quantite || formData.quantite <= 0) {
        throw new Error("Please enter a valid quantity");
      }
      if (!formData.prix_vente_unitaire || formData.prix_vente_unitaire <= 0) {
        throw new Error("Please enter a valid unit price");
      }

      // Check stock availability
      const product = products.find(
        (p) => p.id_produit === formData.id_produit
      );
      if (!product) {
        throw new Error("Product not found");
      }
      if (formData.quantite > product.stock_actuel) {
        throw new Error(
          `Insufficient stock. Available: ${product.stock_actuel}, Requested: ${formData.quantite}`
        );
      }

      // Prepare data for submission
      const detailData = {
        METHOD: "POST",
        id_vente: saleId,
        id_produit: formData.id_produit,
        quantite: formData.quantite,
        prix_vente_unitaire: formData.prix_vente_unitaire,
        user_cre: localStorage.getItem("username") || "SYSTEM",
      };

      // Send request to API
      const response = await fetch(`${config.apiUrl}/details_ventes.php`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(detailData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to add detail");
      }

      // Handle successful response
      const result = await response.json();
      //console.log("Add detail response:", result);

      // Close modal and reset form
      setIsAddModalOpen(false);
      setFormData({
        id_produit: "",
        quantite: "",
        prix_vente_unitaire: "",
      });
      setSelectedProduct(null);

      // Show success message
      setSnackbar({
        open: true,
        message: "Sale detail added successfully",
        severity: "success",
      });

      // Refresh data if callback provided
      if (onRefreshSaleDetails) {
        await onRefreshSaleDetails();
      }
    } catch (error) {
      //console.error("Error adding detail:", error);
      setError(error.message);
      setSnackbar({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const detailsColumns = [
    {
      field: "designation",
      headerName: "Product",
      flex: 1,
    },
    {
      field: "quantite",
      headerName: "Quantity",
      flex: 1,
      type: "number",
    },
    {
      field: "prix_vente_unitaire",
      headerName: "Unit Price",
      flex: 1,
      type: "number",
    },
    {
      field: "montant_total",
      headerName: "Total Amount",
      flex: 1,
      type: "number",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() => {
            setSelectedDetail(params.row);
            setFormData({
              id_produit: params.row.id_produit,
              quantite: params.row.quantite,
              prix_vente_unitaire: params.row.prix_vente_unitaire,
            });
            setIsEditModalOpen(true);
          }}
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => {
            setSelectedDetail(params.row);
            setIsDeleteModalOpen(true);
          }}
        />,
      ],
    },
  ];

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<AddIcon />}
          onClick={() => {
            setError(null);
            setFormData({
              id_produit: "",
              quantite: "",
              prix_vente_unitaire: "",
            });
            setSelectedProduct(null);
            setIsAddModalOpen(true);
          }}
        >
          Add Detail
        </Button>
      </Box>
      <Box height="75vh">
        <DataGrid
          rows={saleDetails}
          columns={detailsColumns}
          getRowId={(row) => row.id_detail_vente}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          disableSelectionOnClick
        />
      </Box>
      {/* Add Detail Modal */}
      <Dialog
        open={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add Sale Detail</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              select
              fullWidth
              margin="normal"
              name="id_produit"
              label="Product"
              value={formData.id_produit}
              onChange={handleInputChange}
              error={!formData.id_produit}
              helperText={!formData.id_produit ? "Please select a product" : ""}
            >
              {products.map((product) => (
                <MenuItem key={product.id_produit} value={product.id_produit}>
                  {product.designation}
                </MenuItem>
              ))}
            </TextField>

            {selectedProduct && (
              <Typography
                color={
                  selectedProduct.stock_actuel > 0
                    ? "success.main"
                    : "error.main"
                }
                variant="body2"
                sx={{ mt: 1, mb: 2 }}
              >
                Available stock: {selectedProduct.stock_actuel}
              </Typography>
            )}

            <TextField
              fullWidth
              margin="normal"
              name="quantite"
              label="Quantity"
              type="number"
              value={formData.quantite}
              onChange={handleInputChange}
              error={!formData.quantite || formData.quantite <= 0}
              helperText={
                !formData.quantite || formData.quantite <= 0
                  ? "Please enter a valid quantity"
                  : ""
              }
            />

            <TextField
              fullWidth
              margin="normal"
              name="prix_vente_unitaire"
              label="Unit Price"
              type="number"
              value={formData.prix_vente_unitaire}
              onChange={handleInputChange}
              error={
                !formData.prix_vente_unitaire ||
                formData.prix_vente_unitaire <= 0
              }
              helperText={
                !formData.prix_vente_unitaire ||
                formData.prix_vente_unitaire <= 0
                  ? "Please enter a valid price"
                  : ""
              }
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsAddModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleAdd}
            variant="contained"
            color="secondary"
            disabled={
              !formData.id_produit ||
              !formData.quantite ||
              !formData.prix_vente_unitaire ||
              (selectedProduct &&
                formData.quantite > selectedProduct.stock_actuel)
            }
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
      {/* Edit Detail Modal */}
      <Dialog open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
        <DialogTitle>Edit Sale Detail</DialogTitle>
        <DialogContent>
          <TextField
            select
            fullWidth
            margin="dense"
            name="id_produit"
            label="Product"
            value={formData.id_produit}
            onChange={handleInputChange}
            error={!formData.id_produit}
          >
            {products.map((product) => (
              <MenuItem key={product.id_produit} value={product.id_produit}>
                {product.designation}
              </MenuItem>
            ))}
          </TextField>

          {selectedProduct && (
            <Typography
              color={
                selectedProduct.stock_actuel > 0 ? "success.main" : "error.main"
              }
              variant="body2"
              sx={{ mt: 1 }}
            >
              Available stock: {selectedProduct.stock_actuel}
              {selectedDetail &&
                ` (${selectedProduct.stock_actuel + selectedDetail.quantite} including current quantity)`}
            </Typography>
          )}

          <TextField
            fullWidth
            margin="dense"
            name="quantite"
            label="Quantity"
            type="number"
            value={formData.quantite}
            onChange={handleInputChange}
            error={
              !formData.quantite ||
              formData.quantite <= 0 ||
              (selectedProduct &&
                formData.quantite - (selectedDetail?.quantite || 0) >
                  selectedProduct.stock_actuel)
            }
          />

          <TextField
            fullWidth
            margin="dense"
            name="prix_vente_unitaire"
            label="Unit Price"
            type="number"
            value={formData.prix_vente_unitaire}
            onChange={handleInputChange}
            error={
              !formData.prix_vente_unitaire || formData.prix_vente_unitaire <= 0
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsEditModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleEdit}
            variant="contained"
            color="secondary"
            disabled={
              !selectedProduct ||
              formData.quantite - (selectedDetail?.quantite || 0) >
                selectedProduct.stock_actuel
            }
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Modal */}
      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this sale detail?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
          <Button onClick={handleDelete} variant="contained" color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Amount Adjustment Modal */}
      <Dialog
        open={isAdjustmentModalOpen}
        onClose={() => setIsAdjustmentModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <SaleAmountAdjustmentHandler
            currentTotal={calculateTotalAmount(saleDetails)}
            newTotal={
              selectedDetail
                ? calculateTotalAmount(
                    saleDetails.filter(
                      (detail) =>
                        detail.id_detail_vente !==
                        selectedDetail.id_detail_vente
                    )
                  )
                : 0
            }
            paidAmount={paidAmount}
            onRefund={() => {
              setIsAdjustmentModalOpen(false);
              setIsRefundModalOpen(true);
            }}
            onCancel={() => setIsAdjustmentModalOpen(false)}
            colors={colors}
          />
        </DialogContent>
      </Dialog>
      {/* Refund Form Modal */}
      <Dialog
        open={isRefundModalOpen}
        onClose={() => setIsRefundModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <RefundForm
            refundAmount={refundAmount}
            onSubmit={handleRefundProcess}
            onCancel={() => setIsRefundModalOpen(false)}
            colors={colors}
            saleId={saleId}
            paymentPlanId={paymentPlanId}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={isAdjustmentModalOpen}
        onClose={() => {
          //console.log("Closing adjustment modal");
          setIsAdjustmentModalOpen(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <SaleAmountAdjustmentHandler
            currentTotal={
              selectedDetail?.calculated?.currentTotal ||
              calculateTotalAmount(saleDetails)
            }
            newTotal={selectedDetail?.calculated?.newTotal || 0}
            paidAmount={paidAmount}
            onRefund={() => {
              setIsAdjustmentModalOpen(false);
              setIsRefundModalOpen(true);
            }}
            onCancel={() => setIsAdjustmentModalOpen(false)}
            colors={colors}
          />
        </DialogContent>
      </Dialog>

      {/* Refund Form Dialog */}
      <Dialog
        open={isRefundModalOpen}
        onClose={() => {
          setIsRefundModalOpen(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <RefundForm
            refundAmount={refundAmount}
            onSubmit={handleRefundProcess}
            onCancel={() => {
              //console.log("Refund cancelled");
              setIsRefundModalOpen(false);
            }}
            colors={colors}
            saleId={saleId}
            paymentPlanId={paymentPlanId}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SaleDetailsGrid;
